import { productListLineStyles as styles } from "@dillon/Overrides/Widgets/MyListsDetails/MyListsDetailsProductListLine";
import { colorStrings, mediaQueriesBP } from "@dillon/Utilities/variables";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.uomGridItem = {
    ...styles.uomGridItem,
    css: css `
        &:empty{
            display: none!important;
        }
    `
}
